import { useState } from 'react';
import classes from './PersonAvatar.module.css';
import { initials } from './TopBar.js';

/**
 * Kişi görseli: fotoğraf varsa fotoğraf (personel kartı; ADR 0158 §1), yoksa ya da açılamazsa baş
 * harfler, açık mavi daire. Boyut px. Fotoğraf süsleyicidir; adı yanındaki metin söyler.
 */
export function PersonAvatar({
  name,
  size = 40,
  src = null,
}: {
  name: string;
  size?: number;
  src?: string | null;
}) {
  const [failed, setFailed] = useState<string | null>(null);
  const photo = src && failed !== src ? src : null;
  return (
    <span
      className={classes.avatar}
      style={{ width: size, height: size, fontSize: Math.round(size * 0.36) }}
      aria-hidden
    >
      {photo ? (
        <img
          className={classes.photo}
          src={photo}
          alt=""
          width={size}
          height={size}
          loading="lazy"
          decoding="async"
          onError={() => setFailed(photo)}
        />
      ) : (
        initials(name)
      )}
    </span>
  );
}
